import { createSwiperProductBlocks, _t } from './base'
import { handleFreeShipping } from './global'

export function initAdvancedOrder() {
    document.addEventListener('ShoptetDOMAdvancedOrderLoaded', () => {
        handleFreeShipping()

        setTimeout(() => {
            addProductsHeader()
            createSwiperProductBlocks('.advanced-order .products-wrapper', true)
            $('.advanced-order .swiper-products-container').show()

            setTimeout(() => {
                // resizeModalHeight()
            }, 200)
        }, 200)
    })
}

function resizeModalHeight() {
    const modalHeight = $('.colorbox-html-content').outerHeight(true)
    $('#cboxLoadedContent').css('height', modalHeight)
}
function addProductsHeader() {
    setTimeout(() => {
        $(`<h2>${_t('advancedOrder.productsHeader')}</h2>`).prependTo(
            '.advanced-order .swiper-products-container'
        )
    }, 100)
}
